import React, { useEffect, useState } from "react";

import "./InvoicesList.scss";
import { InvoiceSummaryRow } from "../../containers/NewOrderContainer/types";
import StorageIcon from "@material-ui/icons/Storage";
import { MenuProps, TablePagination } from "@material-ui/core";
import withStyles from "@material-ui/core/styles/withStyles";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Button from "@material-ui/core/Button";
import ListItemText from "@material-ui/core/ListItemText";
import PageviewIcon from "@material-ui/icons/Pageview";
import MenuIcon from "@material-ui/icons/Menu";
import ImportExportIcon from "@material-ui/icons/ImportExport";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import GetAppIcon from "@material-ui/icons/GetApp";
import ContactMailIcon from "@material-ui/icons/ContactMail";
import { MoneyCorpPermissions } from "../../hooks/usePermissions/usePermissions";

const InvoicesList = (props: {
  invoices?: InvoiceSummaryRow[];
  paginationInfo?: any;
  onChangePageNumber?: any;
  onChangePageSize?: any;
  className?: string;
  onSort?: (x: any) => void;
  permissions?: MoneyCorpPermissions;
  sortCriteria?: any;
}) => {
  const sortBy = props.sortCriteria && props.sortCriteria.sortBy;
  const sortDirection = props.sortCriteria && props.sortCriteria.sortDirection;

  const [rowsPerPage, setRowsPerPage] = useState<number>(10);
  const [page, setPage] = React.useState(
    props.paginationInfo ? props.paginationInfo.currentPage || 0 : 0
  );
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [currentInvoice, setCurrentInvoice] = React.useState();
  const [sortCriteria, setSortCriteria] = useState<any>({
    sortBy: sortBy,
    sortDirection: sortDirection
  });
  const [sortClickCount, setSortClickCount] = React.useState(0);

  useEffect(() => {
    setSortCriteria({ sortBy, sortDirection });
  }, [sortBy, sortDirection]);

  const handleHamburgerMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    invoice: any
  ) => {
    setCurrentInvoice(invoice);
    setAnchorEl(event.currentTarget);
  };

  const handleHamburgerMenuClose = () => {
    setAnchorEl(null);
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    props.onChangePageNumber(newPage + 1);
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setPage(0);
    props.onChangePageNumber(1);
    props.onChangePageSize(parseInt(event.target.value, 10));
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  function handleSorting(headerName: number) {
    if (sortCriteria.sortBy === headerName) {
      if (sortClickCount % 2 === 0) {
        setSortCriteria({ sortBy: headerName, sortDirection: 1 });
        props.onSort && props.onSort({ sortBy: headerName, sortDirection: 1 });
      } else {
        setSortCriteria({ sortBy: headerName, sortDirection: 0 });
        props.onSort && props.onSort({ sortBy: headerName, sortDirection: 0 });
      }
      setSortClickCount(n => n + 1);
    } else if (sortCriteria.sortBy !== headerName) {
      setSortCriteria({ sortBy: headerName, sortDirection: 0 });
      props.onSort && props.onSort({ sortBy: headerName, sortDirection: 0 });
      setSortClickCount(0);
    }
  }

  const StyledMenu = withStyles({
    paper: {
      border: "1px solid #d3d4d5"
    }
  })((props: MenuProps) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center"
      }}
      {...props}
    />
  ));

  const StyledMenuItem = withStyles(theme => ({
    root: {
      "&:focus": {
        backgroundColor: theme.palette.primary.main,
        "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
          color: theme.palette.common.white
        }
      }
    }
  }))(MenuItem);

  return (
    <>
      <div className="InvoicesList--pagination-container">
        <TablePagination
          component="div"
          count={props.paginationInfo.totalCount || 0}
          page={page}
          onChangePage={handleChangePage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50, 100, 200]}
          onChangeRowsPerPage={handleChangeRowsPerPage}
        />
      </div>

      <table className={`InvoicesList-container ${props.className || ""}`}>
        <thead className="InvoicesList--headPanel">
          <tr className="InvoicesList--headPanelRow">
            <th onClick={() => handleSorting(0)}>
              <div className="InvoicesList--tableHeader InvoicesList-numberHeading">
                <div>Number</div>
                {sortCriteria.sortBy === 0 &&
                sortCriteria.sortDirection === 0 ? (
                  <ArrowUpwardIcon className="InvoicesList--ascendingIcon" />
                ) : sortCriteria.sortBy === 0 &&
                  sortCriteria.sortDirection === 1 ? (
                  <ArrowDownwardIcon className="InvoicesList--descendingIcon" />
                ) : (
                  <ImportExportIcon className="InvoicesList--unsortedIcon" />
                )}
              </div>
            </th>
            <th onClick={() => handleSorting(1)}>
              <div className="InvoicesList--tableHeader">
                <div>Branch</div>
                {sortCriteria.sortBy === 1 &&
                sortCriteria.sortDirection === 0 ? (
                  <ArrowUpwardIcon className="InvoicesList--ascendingIcon" />
                ) : sortCriteria.sortBy === 1 &&
                  sortCriteria.sortDirection === 1 ? (
                  <ArrowDownwardIcon className="InvoicesList--descendingIcon" />
                ) : (
                  <ImportExportIcon className="InvoicesList--unsortedIcon" />
                )}
              </div>
            </th>
            <th onClick={() => handleSorting(2)}>
              <div className="InvoicesList--tableHeader">
                <div>Date Raised</div>
                {sortCriteria.sortBy === 2 &&
                sortCriteria.sortDirection === 0 ? (
                  <ArrowUpwardIcon className="InvoicesList--ascendingIcon" />
                ) : sortCriteria.sortBy === 2 &&
                  sortCriteria.sortDirection === 1 ? (
                  <ArrowDownwardIcon className="InvoicesList--descendingIcon" />
                ) : (
                  <ImportExportIcon className="InvoicesList--unsortedIcon" />
                )}
              </div>
            </th>
            <th onClick={() => handleSorting(3)}>
              <div className="InvoicesList--tableHeader">
                <div>Raised By</div>
                {sortCriteria.sortBy === 3 &&
                sortCriteria.sortDirection === 0 ? (
                  <ArrowUpwardIcon className="InvoicesList--ascendingIcon" />
                ) : sortCriteria.sortBy === 3 &&
                  sortCriteria.sortDirection === 1 ? (
                  <ArrowDownwardIcon className="InvoicesList--descendingIcon" />
                ) : (
                  <ImportExportIcon className="InvoicesList--unsortedIcon" />
                )}
              </div>
            </th>
            <th className="numeric" onClick={() => handleSorting(4)}>
              <div className="InvoicesList--tableHeader InvoicesList-amountHeading">
                <div>Amount</div>
                {sortCriteria.sortBy === 4 &&
                sortCriteria.sortDirection === 0 ? (
                  <ArrowUpwardIcon className="InvoicesList--ascendingIcon" />
                ) : sortCriteria.sortBy === 4 &&
                  sortCriteria.sortDirection === 1 ? (
                  <ArrowDownwardIcon className="InvoicesList--descendingIcon" />
                ) : (
                  <ImportExportIcon className="InvoicesList--unsortedIcon" />
                )}
              </div>
            </th>
            <th className="InvoicesList-hamBurgerMenuHeader"></th>
          </tr>
        </thead>
        <tbody>
          {props.invoices &&
            props.invoices.map((invoice: InvoiceSummaryRow) => (
              <tr className="InvoicesList--row">
                <td className="InvoicesList--number">{invoice.number}</td>
                <td className="InvoicesList--branch">{invoice.branch}</td>
                <td className="InvoicesList--dateRaised">
                  {invoice.dateRaised}
                </td>
                <td className="InvoicesList--raisedBy">{invoice.raisedBy}</td>
                <td className="InvoicesList--amount numeric">
                  {invoice.amount.toLocaleString(navigator.language, {
                    minimumFractionDigits: 2
                  })}
                </td>
                <td className="InvoicesList--hamburgerMenu">
                  <Button
                    aria-controls="customized-menu"
                    aria-haspopup="true"
                    onClick={(evt: React.MouseEvent<HTMLElement>) =>
                      handleHamburgerMenuClick(evt, invoice)
                    }
                  >
                    <MenuIcon />
                  </Button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
      {props.invoices && props.invoices.length === 0 ? (
        <div className="OrderHistoryTable--noDataContainer">
          <StorageIcon className="OrderHistoryTable--noDataIcon" />
          <p className="OrderHistoryTable--noDataText">
            There are currently no invoices to display.
          </p>
        </div>
      ) : (
        <></>
      )}
      <StyledMenu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleHamburgerMenuClose}
      >
        <a
          className="InvoicesList-viewPDFLink"
          href={`/api/invoices/${
            (currentInvoice || { id: "" }).id
          }/pdf?view=true`}
          target="_new"
        >
          <StyledMenuItem>
            <ListItemIcon>
              <PageviewIcon fontSize="large" />
            </ListItemIcon>
            <ListItemText primary="View PDF" />
          </StyledMenuItem>
        </a>
        <a
          className="InvoicesList-downloadPDFLink"
          href={`/api/invoices/${
            (currentInvoice || { id: "" }).id
          }/pdf?view=false`}
          target="_new"
        >
          <StyledMenuItem>
            <ListItemIcon>
              <GetAppIcon fontSize="large" />
            </ListItemIcon>
            <ListItemText primary="Download PDF" />
          </StyledMenuItem>
        </a>
        <a
          className="InvoicesList-addressLabelPDFLink"
          href={`/api/invoices/${
            (currentInvoice || { id: "" }).id
          }/address?view=true`}
          target="_new"
        >
          <StyledMenuItem>
            <ListItemIcon>
              <ContactMailIcon fontSize="large" />
            </ListItemIcon>
            <ListItemText primary="Address Label PDF" />
          </StyledMenuItem>
        </a>
      </StyledMenu>
    </>
  );
};

export default InvoicesList;
